module.exports = "<div style=\"color:black\"> In Progress...</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/Components/Permissions/Permissions.html
// module id = 645
// module chunks = 1